import {
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  Grid2,
  Stack,
  Typography,
} from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { Link } from "react-router-dom";

const CourseReviewGrid = ({
  title,
  description,
  courses,
  counts,
  actionLabel,
  to,
}) => (
  <>
    <Box sx={{ mb: 3 }}>
      <Typography variant="h4">{title}</Typography>
      <Typography color="text.secondary">{description}</Typography>
    </Box>
    <Grid2 container spacing={2.5}>
      {courses.map((course) => (
        <Grid2 key={course._id} size={{ xs: 12, sm: 6, lg: 4 }}>
          <Card sx={{ height: "100%" }}>
            <CardContent
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
              <Box sx={{ position: "relative", pr: 5, minHeight: 34 }}>
                <Typography variant="h6">{course.name}</Typography>
                <Badge
                  badgeContent={counts[course._id] || 0}
                  color="secondary"
                  max={99}
                  sx={{ position: "absolute", top: 8, right: 6 }}
                >
                  <Box sx={{ width: 8, height: 8 }} />
                </Badge>
              </Box>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 0.75 }}
              >
                {course.description}
              </Typography>
              <Stack direction="row" sx={{ mt: "auto", pt: 2 }}>
                <Button
                  variant="contained"
                  component={Link}
                  to={to(course)}
                  endIcon={<ArrowForward />}
                >
                  {actionLabel}
                </Button>
              </Stack>
            </CardContent>
          </Card>
        </Grid2>
      ))}
    </Grid2>
  </>
);

export default CourseReviewGrid;
